// Modules
import cn from 'classnames';

// Types
import type { TNavbarProps } from './Navbar.type';

// Styles
import styles from './styles.module.scss';

// Helpers
import { isEmpty, kebabCase } from '../../helpers';

const Navbar = (props: TNavbarProps) => {
	const {
		className,
		listMenu,
		subMenuClassName,
		...restProps
	} = props;

	const navbarCN = cn(styles.legion_navbar, className);
	const menuWrapperCN = cn(styles.navbar_menu_wrapper);
	const subMenuWrapperCN = cn(styles.navbar_submenu_wrapper, subMenuClassName);

	return (
		<nav className={navbarCN} {...restProps}>
			{listMenu.map((item, index) => {
				const { menu, subMenu } = item;
				const { label: menuLabel, isActive: menuIsActive } = menu;
				const menuCN = cn(styles.navbar_menu, {
					[styles.active]: menuIsActive,
				});

				return (
					<div className={menuWrapperCN} key={index}>
						<div className={menuCN}>
							{menuLabel}
							{!isEmpty(subMenu) && (
								<i className={styles.navbar_menu_arrow}/>
							)}
						</div>
						{!isEmpty(subMenu) && (
							<div className={subMenuWrapperCN}>
								{subMenu?.map((subItem, subIndex) => {
									const subKey = kebabCase(`${index}-${subIndex}`);
									const { label: subMenuLabel, isActive: subMenuIsActive } = subItem;
									const subMenuCN = cn(styles.navbar_submenu, {
										[styles.active]: subMenuIsActive,
									});

									return (
										<div key={subKey} className={subMenuCN}>
											{subMenuLabel}
										</div>
									)
								})}
							</div>
						)}
					</div>
				)
			})}
		</nav>
	)
}

export default Navbar;
